import { render, staticRenderFns } from "./after-sales.vue?vue&type=template&id=be51e1b0&scoped=true"
import script from "./after-sales.vue?vue&type=script&lang=js"
export * from "./after-sales.vue?vue&type=script&lang=js"
import style0 from "./after-sales.vue?vue&type=style&index=0&id=be51e1b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be51e1b0",
  null
  
)

export default component.exports